import React__default from 'react';
import { View, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-e658d3b6.esm.js';
import { A as AppText } from './index-495429ce.esm.js';

const AppInputLabel = _ref => {
  let {
    label,
    isMandatory,
    autoMargin,
    fontWeight = "bold",
    style,
    labelTextStyle
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator(currentTheme, autoMargin);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.container, style]
  }, /*#__PURE__*/React__default.createElement(AppText, {
    fontWeight: fontWeight,
    numberOfLines: 2,
    style: labelTextStyle
  }, `${label}`), isMandatory && /*#__PURE__*/React__default.createElement(AppText, {
    fontWeight: fontWeight
  }, `*`));
};
const styleGenerator = (props, autoMargin) => {
  return StyleSheet.create({
    container: {
      marginLeft: 10,
      marginBottom: 10,
      marginTop: autoMargin ? 10 : 0,
      flexDirection: "row"
    }
  });
};
AppInputLabel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppInputLabel",
  "props": {
    "fontWeight": {
      "defaultValue": {
        "value": "\"bold\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "label": {
      "required": true,
      "tsType": {
        "name": "string"
      },
      "description": "Text displayed next to the input"
    },
    "isMandatory": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, it applies an asterix next to the label to highlight it is a mandatory field"
    },
    "autoMargin": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, it applies 10dp marging to left and right"
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Sets the style of the overall view containing the label"
    },
    "labelTextStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    }
  }
};

export { AppInputLabel as A };
